var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSearchBold = function SvgSearchBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 17.25L13.5 13.5M2.75 9a6.25 6.25 0 1112.5 0 6.25 6.25 0 01-12.5 0z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjAnIGhlaWdodD0nMjAnIHZpZXdCb3g9JzAgMCAyMCAyMCcgZmlsbD0nbm9uZScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz4KICA8cGF0aAogICAgZD0nTTE3LjI1IDE3LjI1TDEzLjUgMTMuNU0yLjc1IDlDMi43NSA1LjU0ODIyIDUuNTQ4MjIgMi43NSA5IDIuNzVDMTIuNDUxOCAyLjc1IDE1LjI1IDUuNTQ4MjIgMTUuMjUgOUMxNS4yNSAxMi40NTE4IDEyLjQ1MTggMTUuMjUgOSAxNS4yNUM1LjU0ODIyIDE1LjI1IDIuNzUgMTIuNDUxOCAyLjc1IDlaJwogICAgc3Ryb2tlPSdjdXJyZW50Q29sb3InCiAgICBzdHJva2Utd2lkdGg9JzEuNScKICAgIHN0cm9rZS1saW5lY2FwPSdyb3VuZCcKICAgIHN0cm9rZS1saW5lam9pbj0ncm91bmQnCiAgLz4KPC9zdmc+";
export { SvgSearchBold as ReactComponent };